// extracted by mini-css-extract-plugin
module.exports = {"copyIcon":"styles_copyIcon__d7sOL","copied":"styles_copied__C_gIX"};